import type { StyleSpecification } from "maplibre-gl";

/**
 * Distinguished, low-key basemap built on CartoDB Voyager raster tiles.
 * Glyphs are served by demotiles.maplibre.org which has verified support
 * for the "Noto Sans" family used in our symbol layers.
 */
export const BASE_STYLE: StyleSpecification = {
  version: 8,
  glyphs: "https://demotiles.maplibre.org/font/{fontstack}/{range}.pbf",
  sources: {
    "carto-voyager": {
      type: "raster",
      tiles: [
        "https://a.basemaps.cartocdn.com/rastertiles/voyager/{z}/{x}/{y}@2x.png",
        "https://b.basemaps.cartocdn.com/rastertiles/voyager/{z}/{x}/{y}@2x.png",
        "https://c.basemaps.cartocdn.com/rastertiles/voyager/{z}/{x}/{y}@2x.png",
        "https://d.basemaps.cartocdn.com/rastertiles/voyager/{z}/{x}/{y}@2x.png",
      ],
      tileSize: 256,
      attribution:
        '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> &copy; <a href="https://carto.com/attributions">CARTO</a>',
    },
  },
  layers: [
    {
      id: "carto-voyager-layer",
      type: "raster",
      source: "carto-voyager",
      minzoom: 0,
      maxzoom: 22,
    },
  ],
};

/**
 * View constraints — keep users focused on the dataset's region.
 * Bounds cover Türkiye + a small buffer so panning never strands the
 * viewport over Egypt/Russia/etc., where there is no data.
 */
export const TR_MAX_BOUNDS: [[number, number], [number, number]] = [
  [22.0, 33.5], // SW
  [48.0, 43.5], // NE
];
export const MIN_ZOOM = 5;
export const MAX_ZOOM = 17;
export const INITIAL_CENTER: [number, number] = [35.2433, 38.9637];
export const INITIAL_ZOOM = 5.4;
